import React from "react";
import Footer from "../components/Footer";
import NavigationBar from "../components/NavigationBar";
import Sidebar from "../components/Sidebar";

const Layout = (props) => {
  return (
    <div /* className="layout" */>
      <div className="layout-sidebar">
        <Sidebar rest={process.env.REACT_APP_PRODUCTION_ROOT_PATH + process.env.REACT_APP_PORUKE_PATH}/>
      </div>
      <div className="layout-content-wrapper">
      <div className="layout-navigation-bar">
          <NavigationBar rest={process.env.REACT_APP_PRODUCTION_ROOT_PATH + process.env.REACT_APP_PORUKE_PATH}/>
        </div>
        <div>{props.children}</div>
        <div className="layout-footer">
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Layout;
